import React from 'react';
import { Button, Card, CardContent, MenuItem, Stack, TextField, Typography } from '@mui/material';

import { toDateTimeValue } from './approvalWorkflowFormatters';

export default function ApprovalAuditFilterCard({ auditFilter, onFilterChange, onRefresh, onReset }) {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Audit-Log filtern
                </Typography>
                <Stack spacing={2}>
                    <TextField
                        select
                        label="Entität"
                        name="entityType"
                        value={auditFilter.entityType}
                        onChange={onFilterChange}
                        fullWidth
                    >
                        <MenuItem value="">Alle</MenuItem>
                        <MenuItem value="ApprovalRequest">Freigabe</MenuItem>
                    </TextField>
                    <TextField
                        label="Entitäts-ID"
                        name="entityId"
                        value={auditFilter.entityId}
                        onChange={onFilterChange}
                        fullWidth
                    />
                    <TextField
                        label="Aktion"
                        name="action"
                        value={auditFilter.action}
                        onChange={onFilterChange}
                        fullWidth
                        helperText="z. B. CREATED, APPROVED, REJECTED"
                    />
                    <TextField
                        label="Mitarbeiter-ID"
                        name="actorId"
                        value={auditFilter.actorId}
                        onChange={onFilterChange}
                        fullWidth
                    />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                            label="Von"
                            type="datetime-local"
                            name="from"
                            value={toDateTimeValue(auditFilter.from)}
                            onChange={onFilterChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                        <TextField
                            label="Bis"
                            type="datetime-local"
                            name="to"
                            value={toDateTimeValue(auditFilter.to)}
                            onChange={onFilterChange}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                        />
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Button variant="outlined" onClick={onRefresh}>
                            Audit aktualisieren
                        </Button>
                        <Button variant="text" onClick={onReset}>
                            Filter zurücksetzen
                        </Button>
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
}
